const Footer = () => {
    const FooterYear = new Date()?.getUTCFullYear()
    return (
        <footer>
            <p className="text_center"><span>Copyright © {FooterYear} University of Southern California | <span> <a rel="noreferrer" target="_blank" href='https://policy.usc.edu/protecting-minors/'> Youth Protection Policy </a> | <a href='https://eeotix.usc.edu/notice-of-non-discrimination/' target='_blank'>Non-Discrimination Policy</a> | <a href='https://www.usc.edu/pages/usc-privacy-notice/' target='_blank'>Privacy Notice</a></span></span></p>
        </footer>
    )
};

export default Footer